<app-page>
  <settings [isModal]="false"></settings>
</app-page>
